import { render, staticRenderFns } from "./SentimentMarketHotTrend.vue?vue&type=template&id=0e2c2d80&scoped=true"
import script from "./SentimentMarketHotTrend.vue?vue&type=script&lang=js"
export * from "./SentimentMarketHotTrend.vue?vue&type=script&lang=js"
import style0 from "./SentimentMarketHotTrend.vue?vue&type=style&index=0&id=0e2c2d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2c2d80",
  null
  
)

export default component.exports